import { TranslateService } from '@ngx-translate/core';
import { SubscribeService } from './../api/subscribe.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from '@angular/material/icon';



@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscribeComponent implements OnInit {

  @ViewChild('fileInput') fileUploader: ElementRef;
  @ViewChild('fileInputBack') fileUploaderBack: ElementRef;

  @ViewChild('cardInput') cardUploader: ElementRef;
  @ViewChild('cardInputBack') cardUploaderBack: ElementRef;

  constructor(private route: ActivatedRoute, private translate: TranslateService, private subscribeService: SubscribeService, public snackBar: MatSnackBar, public router: Router, private formBuilder: FormBuilder,  private domSanitizer: DomSanitizer) 
  { 
    this.route.queryParamMap.subscribe(query => {
      let param = query.get('covoiturage')
 
      console.log("========== covoiturage ==============")
     console.log(this.covoiturage)
     if(param === 'true'){
      this.covoiturage = true
     }
    
   });
  }

  //url api
  // private apiUrl = environment.apiUrl
  
  formGroup: FormGroup;
  submitted = false;
  loading = false;
  covoiturage = false

  nameFilePermis: string;
  nameFilePermisBack: string;

  nameFileCard: string;
  nameFileCardBack: string;

  maxDate = new Date(new Date().getFullYear() - 16, 0, 30);
  birthdate : Date
 
  
  
  color: ThemePalette = 'accent';


  ngOnInit(): void {

    this.createForm();
  }

  createForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let caracereregex: RegExp = /^[a-zA-Z -]+$/;
    let usernameregex: RegExp = /^[a-zA-Z-_@.]+$/;
    

    this.formGroup = this.formBuilder.group({
      lastname: [null, [Validators.required, Validators.pattern(caracereregex)]],
      firstname: [null, [Validators.required, Validators.pattern(caracereregex)]],
      name: [null, [Validators.required,  Validators.pattern(usernameregex)]],
      birthdate: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.pattern(emailregex)]],
      phonenumber: [null, [Validators.required]],
      company: [null],
      invitation: [null],
      license: [''],
      license_back: [''],
      id_card: [''],
      id_card_back: [''],
      cgu: [false, Validators.requiredTrue]
    }
    );
  }




  getErrorLastname() {
    return this.formGroup.get('lastname').hasError('required') ? 'Nom requis' :
      this.formGroup.get('lastname').hasError('pattern') ? 'Nom non valide' : 'Nom non valide';
  }

  getErrorFirstname() {
    return this.formGroup.get('firstname').hasError('required') ? 'Prénom requis' :
      this.formGroup.get('firstname').hasError('pattern') ? 'Prénom non valide' : 'Prénom non valide';
  }

  getErrorPhonenumber() {
    return this.formGroup.get('phonenumber').hasError('required') ? 'Numéro de téléphone requis': 
    this.formGroup.controls['phonenumber'].valid  ? '' : 'Numéro de téléphone non valide';
  }

  getErrorUsername() {
    return this.formGroup.get('name').hasError('required') ? 'Nom d’utilisateur requis' :
    this.formGroup.get('name').hasError('pattern') ? 'Nom d’utilisateur non valide' : 'Nom d’utilisateur non valide';
  }


  getErrorCompany() {
    return this.formGroup.get('company').hasError('required') ? 'Société requise' : '';
  }

  getErrorInvitation() {
    return this.formGroup.get('invitation').hasError('required') ? 'Code  d’invitation requis' : '';
  }

  getErrorDate() {
    return this.formGroup.get('birthdate').hasError('required') ? 'Date de naissance requise' : '';
  }

 
  getErrorEmail() {
    return this.formGroup.get('email').hasError('required') ? 'Adresse email requise' :
      this.formGroup.get('email').hasError('pattern') ? 'Adresse email non valide' : '';
  }

  
 


  

  get f() { return this.formGroup.controls; }


  fileChangePermis(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        this.openSnackBar(this.translate.instant('ERREURSUBSCRIBE.FORMAT'))
        return this.fileUploader.nativeElement.value = null;
      }

      this.nameFilePermis = file.name
      let typeFile = file.type

      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log(' permis recto convertir');
              this.formGroup.get('license').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log('permis recto sans convertir');
            this.formGroup.get('license').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log('permis recto pdf');
          this.formGroup.get('license').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }
  }


  fileChangeCard(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        this.openSnackBar(this.translate.instant('ERREURSUBSCRIBE.FORMAT'))
        return this.cardUploader.nativeElement.value = null;
      }

      this.nameFileCard = file.name
      let typeFile = file.type

      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log(' recto convertir');
              this.formGroup.get('id_card').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log(' recto sans convertir');
            this.formGroup.get('id_card').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log(' recto pdf');
          this.formGroup.get('id_card').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }
  }



  fileChangePermisBack(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        this.openSnackBar(this.translate.instant('ERREURSUBSCRIBE.FORMAT'))
        return this.fileUploaderBack.nativeElement.value = null;
      }

      this.nameFilePermisBack = file.name
      let typeFile = file.type
      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log(' permis verso convertir');
              this.formGroup.get('license_back').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log('permis verso sans convertir');
            this.formGroup.get('license_back').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log('permis verso pdf');
          this.formGroup.get('license_back').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }
  }


  fileChangeCardBack(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        this.openSnackBar(this.translate.instant('ERREURSUBSCRIBE.FORMAT'))
        return this.cardUploaderBack.nativeElement.value = null;
      }

      this.nameFileCardBack = file.name
      let typeFile = file.type
      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log('  verso convertir');
              this.formGroup.get('id_card_back').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log(' verso sans convertir');
            this.formGroup.get('id_card_back').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log(' verso pdf');
          this.formGroup.get('id_card_back').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }
  }


  openSnackBar(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['blue-snackbar'],
      duration: 20000,
    });
  }


  signUp() {

    console.log(this.formGroup.value)

    this.submitted = true;
  
    if (this.formGroup.invalid ) {
      return;
    }

    this.loading = true;
    let userData = this.formGroup.value;

    if(this.covoiturage === true){
      delete userData.license
      delete userData.license_back
      userData.company = "covoiturage"
      userData.invitation = "clemcovoiturage"
      userData.covoiturage = true
    }

    if(this.covoiturage === false){
      delete userData.id_card
      delete userData.id_card_back
    }
    
    if(userData.license_back === ""){
      delete userData.license_back
    }

    if(userData.company === null){
      this.openSnackBar('Société requise')
      this.loading = false;
      return
    }

    if(userData.invitation === null){
      this.openSnackBar('Code  d’invitation requis')
      this.loading = false;
      return
    }

   


    if(userData.license === "" && this.covoiturage === false){
      this.openSnackBar(this.translate.instant('ERREURSUBSCRIBE.PERMIS'))
      this.loading = false;
      return
    }

    if(userData.id_card === "" && this.covoiturage === true){
      this.openSnackBar("Piece d'identité requise")
      this.loading = false;
      return
    }

   


    userData.birthdate.setHours(15);

  
    this.subscribeService.subscribeB2B(userData).subscribe(
      data => {
  
        this.loading = false;
        this.openSnackBar(data.message)
        this.router.navigate(['/connexion']);

      },
      err => {
        this.loading = false;
        this.openSnackBar(err.error.message)
      });

  }

  

}
